module.exports = __webpack_public_path__ + "static/media/MINDA-Live-blue.25b48cba.svg";